import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-components-videoembed',
  template: `
    <div class="ratio ratio-16x9">
      <iframe
        #iframeRef
        loading="lazy"
        class="ratio-item"
        width="640"
        height="360"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        [attr.title]="title">
      </iframe>
    </div>
  `,
  styleUrls: ['./components-videoembed.component.scss']
})
export class ComponentsVideoembedComponent implements AfterViewInit, OnDestroy {
  @Input() src: 'youtube' | 'vimeo' = 'youtube';
  @Input() url: string = '';
  @Input() title: string = '';

  @ViewChild('iframeRef', { static: true }) iframeRef!: ElementRef<HTMLIFrameElement>;

  private observer!: IntersectionObserver;

  get embedUrl(): string {
    const base = this.src === 'youtube'
      ? 'https://www.youtube.com/embed/'
      : 'https://player.vimeo.com/video/';
    return base + this.url;
  }

  ngAfterViewInit(): void {
    if (this.iframeRef) {
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.iframeRef.nativeElement.src = this.embedUrl;
          this.observer.disconnect(); // Stop observing after loading
        }
      }, {
        rootMargin: '100px',
        threshold: 0.1
      });

      this.observer.observe(this.iframeRef.nativeElement);
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
